<form #form="ngForm" (ngSubmit)="form.valid && submit()">
    <div class="modal-header text-center">
        <div class="d-flex align-items-start">
            <div class="mr-auto">
                <h3 data-test="modal-title" class="modal-title" id="modal-title" translate>Save policy</h3>
            </div>
            <div [class.text-grey]="!closeButtonHover" [class.text-dark-grey]="closeButtonHover">
                <span [attr.aria-label]="'Close' | translate"
                      (mouseover)="closeButtonHover = true"
                      (mouseleave)="closeButtonHover = false"
                      (click)="dismiss.emit({$value: 'Cancelled'})"
                      class="fas fa-times fa-2x">
                </span>
            </div>
        </div>
    </div>
    <div class="modal-body" id="modal-body">
        <form-field-input name="name" [required]="true" [(ngModel)]="policy.name" [label]="'Name' | translate"></form-field-input>
        <form-field-errors [input]="form.name"></form-field-errors>
        <form-field-textarea
                [(ngModel)]="policy.note"
                name="note"
                [label]="'Note' | translate"
                [placeholder]="'Explain the rationale behind the policy and which actions, editors should take to correct the violation' | translate"></form-field-textarea>
    </div>
    <div class="modal-footer text-left">
        <button class="btn btn-border-radius btn-primary"
                data-test="save-button"
                monEventTrigger="actionTrigger"
                [monEventParams]="{action: policy.id ?'policy-edit': 'policy-create', params: policy}"
                type="submit"
                [disabled]="form.invalid || saving"
                translate>
            Save
        </button>
    </div>
</form>
